import React from 'react';
import PropTypes from 'prop-types';

const SVG = ({color = '#B1BAC2', width = 'auto', height = 'auto', className = ''}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>close-30px</title>

    <g>
      <g fill={color} fillRule="nonzero">
        <polygon
          id="Path"
          points="27.2 0 16.0000001 11.2 4.80000001 3.64428927e-14 0 4.80000001 11.2 16.0000001 0 27.2 4.80000001 32 16.0000001 20.8000001 27.2 32 32 27.2 20.8000001 16.0000001 32 4.80000001"
        />
      </g>
    </g>
  </svg>
);

SVG.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

export default SVG;
